angular.module('jv.Admin.Users')
    .controller('jvAdminUsersEmployeeAddEditController',
        ['$scope', 'adminUserSVC', '$location', '$route', '$filter', 'enumToValueMap', 'jvTimezones',
            function($scope,adminUserSVC,$location,$route,$filter, enumToValueMap, jvTimezones) {
                var cachedTemplates = {};
                $scope.error = {};
                $scope.objectEquality = angular.equals;
                $scope.isEmployeeAdd = $location.path().indexOf('add') > -1;
                $scope.employee={};
                $scope.map = enumToValueMap;
                $scope.result = {
                    Employee: {},
                    CheckBox: {},
                    MultiSelect: {}
                };
                $scope.employeeSelect = adminUserSVC.employeeSelect;

                $scope.$watch('$parent.employee.edit', function(newVal, oldVal) {
                    if(newVal) {
                        $scope.employee = {};
                        adminUserSVC.getEmployeeAddEditFields({employeeId: $scope.params.id}, function (response) {
                            if(response.msgInfo === 200) {
                                $scope.selectedTemplate = "";
                                $scope.employeeCopy = angular.copy($scope.$parent.employee.viewFields);
                                angular.extend($scope.employee, response);
                                $scope.employee.inviteEmployeeTemplate = $scope.select2Options.setTemplates($scope.employee.inviteEmployeeTemplate);
                                angular.forEach($scope.employee.inviteEmployeeTemplate, function (template) {
                                   if(template['default']) {
                                       $scope.selectedTemplate = template;
                                   }
                                   cachedTemplates[template.eid] = template;
                                });
                                $scope.invitation = {
                                    sendInvitation: $scope.isEmployeeAdd,
                                    makeTemplateEditable: false
                                };
                                $scope.changeInviteTemplate($scope.selectedTemplate);
                                populateTimezoneValues();
                            }
                            $scope.flags.loading = false;
                        }, function (response) {

                        });
                    }
                });

                if($scope.isEmployeeAdd){
                    $scope.$parent.employee = $scope.$parent.employee || {};
                    $scope.$parent.employee.edit = true;
                }

                function populateTimezoneValues() {
                    jvTimezones.getTimezones().then(function(timezones) {
                        $scope.employee.viewFields.forEach(function(field) {
                            if (field.fieldId === -31) {
                                field.values = timezones.map(function(timezone) {
                                    return {
                                        value: timezone.name,
                                        key: timezone.openSysId
                                    };
                                });
                            }
                        });
                    });
                }

                $scope.type = function (field, normalize) {
                    var type = field && field.fieldType;
                    if(/Name|Phone/g.test(type)) {
                        if(field.fieldId === -3) {
                            type = "Email";
                        } else {
                            type = "Name";
                        }
                        if(!field.normalized && normalize) {
                            _setModelValue(field, field.value);
                        }
                    } else if (/Employee/g.test(type)) {
                        type = "Employee";
                        if(!field.normalized && normalize) {
                            _setModelValue(field, field.data);
                        }
                    } else if(type === "CheckBox") {
                        if(field.fieldId === -34){
                            type="CheckBox1";
                        } else {
                            $scope.result['CheckBox'][field.EId] = $scope.result['CheckBox'][field.EId] || {};
                        }
                        if(!field.normalized && normalize) {
                            _setModelValue(field, field.value);
                        }
                    } else if(type === "DropDown") {
                        if(!field.normalized && normalize || ( field.fieldId === -29 && $scope.result[field.EId] && $scope.result[field.EId].trim() === "" && field.value && (field.value).trim() !== "" )) {
                            $scope.result[field.EId] = field.value;
                        }
                    } else if(type === "Date") { 
                        if(field.fieldId === -21) { 
                        	type = "Date1"; 
                            $scope.result[field.EId] = field.value; 
                            $scope.startDateEId = field.EId;
                        } 
                    }  else if(type === "MultiSelect") {
                        $scope.result['MultiSelect'][field.EId] = $scope.result['MultiSelect'][field.EId] || {};
                        if(!field.normalized && normalize) {
                            _setModelValue(field, field.data);
                        }
                    }
                    if(!field.normalized && normalize) {
                        field.normalized = true;
                    }
                    return type;
                };

                var serialize =  function (data) {
                    var checkBoxes = data.CheckBox, checkBoxResult =[], emp = data.Employee, empResult =[], multiSelect = data.MultiSelect, multiSelectResult = [];

                    angular.forEach(data, function (value, key) {
                        if(value === undefined || value === null) {
                            data[key] = "";
                        }
                    });

                    angular.forEach(checkBoxes, function(checkBoxValues, fieldId){
                        data[fieldId]= data[fieldId] || [];
                            angular.forEach(checkBoxValues, function(cbValue, cbKey){
                                if(cbValue){
                                    data[fieldId].push(cbKey);
                                }

                        });
                    });
                    angular.forEach(emp, function(empValue, fieldId){
                        data[fieldId]= data[fieldId] || [];
                        if(empValue){
                            data[fieldId].push(empValue.EId);
                        } else{
                            data[fieldId] = "";
                        }
                    });

                    angular.forEach(multiSelect, function(multiSelectVal, fieldId){
                        data[fieldId]= data[fieldId] || [];
                        if(multiSelectVal){
                            angular.forEach(multiSelectVal, function(cbValue, cbKey){
                                if(cbValue){
                                    data[fieldId].push(cbValue.code);
                                }
                            });     
                        }
                    });

                    data.CheckBox ={};
                    data.Employee = {};
                    data.MultiSelect = {};
                    return data;
                };

                var _getModelValue = function (field) {
                    var type = field && field.fieldType;
                    var modelValue;
                    if(/Name|Phone/g.test(type)) {
                        modelValue = $scope.result[field.EId];
                    } else if (/Employee/g.test(type)) {
                        modelValue = $scope.result['Employee'][field.EId];
                    } else if(type === "CheckBox") {
                           if(field.fieldId === -34){
                                modelValue = $scope.result[field.EId];
                            }else {
                                modelValue = $scope.result['CheckBox'][field.EId];
                            }
                    } else if(type === "MultiSelect") {
                        modelValue = $scope.result['MultiSelect'][field.EId];
                    }
                    return modelValue;
                };
                var _setModelValue = function (field, value) {
                    var type = field && field.fieldType;
                    if(/Name|Phone/g.test(type)) {
                        $scope.result[field.EId] = value && value.trim();
                    } else if (/Employee/g.test(type)) {
                        $scope.result['Employee'][field.EId] = value && value.EId;
                    } else if(type === "CheckBox") {
                        if(field.fieldId === -34){
                            var changedValues = value;
                            $scope.result[field.EId] = changedValues === "true" ? true:false;
                        } else {
                            var values = value && value.split('\n');
                            angular.forEach(values, function (cbval) {
                                $scope.result['CheckBox'][field.EId][cbval] = true;
                            });
                        }

                    } else if(type === "MultiSelect") {
                        var changedValues = value;
                        angular.forEach(changedValues, function(value, key){
                            //User should not be able to remove Employee Role OR default employee_access_group from the system.
                            if ((field.fieldId == -9 && value.code === "ROLE_EMPLOYEE") || (field.fieldId == -35 && value.code === "employee_access_group")) {
                                value.locked = true;
                            }
                        });
                        $scope.result['MultiSelect'][field.EId] = changedValues;
                    }
                };

                $scope.cancelDetails= function() {
                    $scope.$parent.employee.edit = false;
                    $scope.result['CheckBox'] = {};
                    $scope.result['Employee'] = {};
                    $scope.$parent.employee.viewFields = angular.copy($scope.employeeCopy);
                };

                $scope.cancel = function () {
                    $location.path("/users/employees");
                };

                $scope.$parent.confirmUpdateRole = function(params) {
                    $scope.save(params, true);
                };

                $scope.checkIfRoleDisabled = function(role) {
                    //Change to block the current user to add higher roles like SuperUser and Administrator to self
                    if($scope.params.id === _jvselfUser.eid && (role.key === 'ROLE_SUPERUSER' || role.key === 'ROLE_ADMINISTRATOR')) {
	                	return true;
                    }
                	return (role.key === 'ROLE_EMPLOYEE') || role.disabled || (role.key === 'ROLE_JOBAPPROVER' && $scope.employee.isApprovalDisabled)
                };

                $scope.save = function (addMore, avoidRoleCheck) {

                    $scope.emptyRequiredFields = _validate($scope.result);
                    if($scope.emptyRequiredFields.length > 0) {
                        scrollTo($scope.emptyRequiredFields[0]);
                        return;
                    }
                    if(!avoidRoleCheck && isReqOwnerCheckRequired()){
                        var params = {
                            ownerIds: $scope.params.id,
                            jobStateValue: 1009,
                            maxResults: -1
                        };
                        adminUserSVC.getReqsList($.param(params), function(response,code){
                            if(code == 200 && response.jobs.length > 0){
                                $scope.flags.loading = false;
                                $scope.reqList = {};
                                $scope.reqList.response = response;
                                $scope.reqList.modal = {};
                                $scope.reqList.showRemove = false;
                                $scope.reqList.showRoleUpdate = true;
                                $scope.reqList.modal.show = true;
                                $scope.reqList.modal.header = i18n["UPDATE_ROLE"];
                                $scope.reqList.updateParams = addMore;
                                $scope.$parent.reqList = $scope.reqList;
                            } else{
                                $scope.save(addMore, true);
                            }
                        });
                        return;
                    }
                    if($scope.reqList && $scope.reqList.modal){
                        $scope.reqList.modal.show= false;
                    }
                    checkForInvitation();
                    if($scope.result['subject'] && $scope.result['content']){
                        $scope.result['locale'] = $scope.selectedTemplate['locale'];
                    }
                    if($scope.startDateEId && $scope.startDateEId.trim() !== "") {
                		var dateArr = $scope.result[$scope.startDateEId].split("/");
                		$scope.result[$scope.startDateEId] = dateArr[2] + "-" + dateArr[0] + "-" + dateArr[1];
                	}
                    var data = serialize(angular.copy($scope.result));
                    $scope.flags.loading = true;
                    adminUserSVC.saveEmployee(data, {id: $scope.params.id}, function (response) {
                        var elementId;
                        if(response.msgInfo === "SUCCESS") {
                            if($scope.isEmployeeAdd && !addMore) {
                                $scope.isEmployeeAdd = false;
                                $(window).off('beforeunload');
                                window.location="/admin/config/users/index.html?readMode=0#/users/employees/msg/EMPLOYEE_ADDED";
                            } else {
                                $route.reload();
                                $scope.showMsg('EMPLOYEE_UPDATED');
                            }
                        } else if (response.msgInfo === "RESEARCHER_LIMIT_REACHED") {
                            elementId = $filter('filter')($scope.employee.viewFields, {fieldId: -9})[0].EId;
                            scrollTo(elementId);
                            var resultCopy = $scope.result['CheckBox'];
                            if ($.isEmptyObject(resultCopy)) {
                                resultCopy = $scope.result['MultiSelect'];
                            }
                            $scope.error['Role'] = {
                                previousRoleValue: resultCopy[elementId],
                                showRoleError: true
                            };
                        } else if(response.msgInfo === "EMAIL_EXIST" || response.msgInfo == 'AGENCY_EXIST' || response.msgInfo == 'EMPLOYEE_EXIST') {
                            elementId = $filter('filter')($scope.employee.viewFields, {fieldId: -3, fieldType: "Name"})[0].EId;
                            scrollTo(elementId);
                            $scope.error['Email'] = {
                                previousEmailValue: $scope.result[elementId],
                                showEmailError: true
                            };
                        } else if(response.msgInfo === "EMPLOYEEID_EXIST") {
                            elementId = $filter('filter')($scope.employee.viewFields, {fieldId: -10, fieldType: "Name"})[0].EId;
                            scrollTo(elementId);
                            $scope.error['EmployeeID'] = {
                                showError: true
                            };
                        } else if(response.msgInfo === 'ATLEAST_ONE_ADMIN') {
                            elementId = $filter('filter')($scope.employee.viewFields, {fieldId: -9})[0].EId;
                            scrollTo(elementId);
                            var resultCopy = $scope.result['CheckBox'];
                            if ($.isEmptyObject(resultCopy)) {
                                resultCopy = $scope.result['MultiSelect'];
                            }
                            $scope.error['Role'] = {
                                previousRoleValue: angular.copy(resultCopy[elementId]),
                                showRoleAdminError: true
                            };
                        } else if(response.msgInfo === 'ATLEAST_ONE_HR') {
                            elementId = $filter('filter')($scope.employee.viewFields, {fieldId: -9})[0].EId;
                            scrollTo(elementId);
                            var resultCopy = $scope.result['CheckBox'];
                            if ($.isEmptyObject(resultCopy)) {
                                resultCopy = $scope.result['MultiSelect'];
                            }
                            $scope.error['Role'] = {
                                previousRoleValue: angular.copy(resultCopy[elementId]),
                                showHRRoleError: true
                            };
                        } else if(response.msgInfo === 'JVIM_SEATS_LIMIT_REACHED') {
                            elementId = $filter('filter')($scope.employee.viewFields, {fieldId: -34 ,fieldType: "CheckBox"})[0].EId;
                            scrollTo(elementId);
                            $scope.error['JVIM'] = {
                                previousJVIMValue: $scope.result[elementId],
                                showSeatError: true
                            };
                        } else {
                            //if response.msgInfo='Error', it could be server server or bad request. Showing this message in that case
                            $scope.showMsg('UNABLE_TO_PERFORM_OPERATION', false, 'error');
                        }
                        $scope.flags.loading = false;
                    }, function (response) {
                        $scope.flags.loading = false;
                    });

                };

                var _validate = function (result) {
                    var emptyRequiredField = [];
                    var fieldValue;
                    angular.forEach($scope.employee.viewFields, function (field) {
                        fieldValue = _getModelValue(field);
                        if(field.required && (angular.isUndefined(fieldValue) || !fieldValue || fieldValue === "")) {
                            emptyRequiredField.push(field.EId);
                        }
                        if(!_validateField($scope.type(field), fieldValue) && emptyRequiredField.indexOf(field.EId) < 0) {
                            emptyRequiredField.push(field.EId);
                        }
                    });
                    if($scope.invitation.sendInvitation) {
                        if(angular.isUndefined($scope.result['subject']) || angular.isUndefined($scope.result['content']) || $scope.result['content'] === "" || $scope.result['subject']) {
                            if(!$scope.result['subject']) {
                                emptyRequiredField.push("subject");
                            }
                            if(!$scope.result['content']) {
                                emptyRequiredField.push("content");
                            }
                        }
                    }
                    return emptyRequiredField;
                };

                var _validateField = function (fieldType, fieldValue) {
                    if(fieldType === "Email") {
                        $scope.previousEmailValue = fieldValue;
                        if(!window.EMAIL_REGEX){
							throw new Error('EMAIL_REGEX is not defined');
						}
						var emailPattern = new RegExp( window.EMAIL_REGEX );	   
   						return emailPattern.test( fieldValue );
                    } else {
                        return true;
                    }
                };

                var checkForInvitation = function () {
                    if((!!$scope.invitation.sendInvitation) === false) {
                        if($scope.result['content']) {
                            delete $scope.result['content'];
                        }
                        if($scope.result['subject']) {
                            delete $scope.result['subject'];
                        }
                    }
                };

                var scrollTo = function (idToScroll) {
                    var top = $('#'+idToScroll).offset().top;
                    $('html,body').animate({ scrollTop: top }, 400);
                };

                $scope.changeInviteTemplate = function (selectedTemplate) {
                    $scope.selectedTemplate = selectedTemplate;
                    if($scope.isEmployeeAdd) {
                        if($scope.selectedTemplate && !$.isEmptyObject(cachedTemplates)) {
                            var template = cachedTemplates[$scope.selectedTemplate.eid];
                            $scope.result['subject'] = template && template.subject;
                            $scope.result['content'] = template && template.body;
                        } else {
                            $scope.selectedTemplate = "";
                            $scope.result['subject'] = "";
                            $scope.result['content'] = "";
                        }
                    }
                };

                var getRoleObject = function(roleList, roleName){
                    var roleObj = {};
                    angular.forEach(roleList, function(role){
                        if(role.value === roleName){
                            roleObj = role;
                        }
                    });
                    return roleObj;
                };

                var isReqOwnerCheckRequired = function() {
                    var isHM = false;
                    var isRecruiter = false; 
                    var checkRequired = false;
                    var fieldId ='';
                    angular.forEach($scope.employeeCopy, function(viewField){
                        if(viewField.name === 'Role'){
                            fieldId = viewField.EId;
                            //non-ERF case
                            if (viewField.fieldType === "CheckBox") {
                                for (var i = 0; i < viewField.data.length; i++) {
                                    if(viewField.data[i] == 'Recruiter'){
                                        isRecruiter = true;
                                    } else if(viewField.data[i] == 'Hiring Manager'){
                                        isHM = true;
                                    }
                                };
                            }
                            //ERF case
                            if (viewField.fieldType === "MultiSelect") {
                                if(angular.isArray(viewField.data)){
                                    for (var i = 0; i < viewField.data.length; i++) {
                                        if(viewField.data[i].type === "Recruiter"){
                                            isRecruiter = true;
                                        } else if(viewField.data[i].type === "HiringManager"){
                                            isHM = true;
                                        }
                                    }
                                }
                            }
                        }
                    });
                    //non-ERF case
                    angular.forEach($scope.result['CheckBox'][fieldId], function(checkState, index) {
                        if(index === 'ROLE_RECRUITER' && isRecruiter) {
                            checkRequired |= !checkState;
                        }
                        if(index === 'ROLE_HIRING_MANAGER' && isHM) {
                            checkRequired |= !checkState;
                        }
                    });

                    //ERF case
                    if (angular.isDefined($scope.result['MultiSelect'][fieldId])) {
                        angular.forEach($scope.result['MultiSelect'][fieldId], function(role) {
                            if(role.type === 'Recruiter') {
                                isRecruiter = false;
                            }
                            if(role.type === 'HiringManager') {
                                isHM = false;
                            }
                        }); 
                        checkRequired = (isHM || isRecruiter);
                    }
                    return checkRequired;
                }
            }
        ]);
